import $ from 'jquery'

if ($('.js-offcanvas-dropdown-toggle').length) {
	$('.js-offcanvas-dropdown-toggle').click(function(e){
		e.preventDefault();
		var $this = $(this);
		$this.closest('.nav-item').find('.offcanvas-dropdown').slideToggle();
		$this.closest('.nav-item').toggleClass('is-open');
	});
}


const myOffcanvas = document.getElementById('mobileNav')

if (myOffcanvas) {
	myOffcanvas.addEventListener('show.bs.offcanvas', event => {
		$('body').toggleClass('has-offcanvas-open');
	})
	myOffcanvas.addEventListener('hide.bs.offcanvas', event => {
		$('body').toggleClass('has-offcanvas-open');
	})
}
